var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSubir(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.722,
    height: 9.617,
    viewBox: "0 0 16.722 9.617",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #002e6b;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_19165",
    "data-name": "Group 19165",
    transform: "translate(20643.142 19577.142)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18596",
    "data-name": "Rectangle 18596",
    className: "cls-1",
    width: 1.774,
    height: 11.824,
    rx: 0.887,
    transform: "translate(-20634.781 -19577.141) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18597",
    "data-name": "Rectangle 18597",
    className: "cls-1",
    width: 1.774,
    height: 11.824,
    rx: 0.887,
    transform: "translate(-20626.42 -19568.781) rotate(135)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSubir);
export default __webpack_public_path__ + "static/media/Icon_subir.aa20078dd6515d214bb07c8c06d996e5.svg";
export { ForwardRef as ReactComponent };